// extracted by mini-css-extract-plugin
export default {"mobile-logo":"hero_mobile-logo__bo09-","mobile-slogan":"hero_mobile-slogan__JF7Ct"};